import Layout from "../../components/layout";
import CardWidgets from "../../components/widgets/CardWidgets";
import { useQuery } from "@tanstack/react-query";
import { getDashboardData } from "../../apis/dashboard";
import Spinner from "../../components/spinner";
import Errors from "../errors";
import { PROJECT_NAME } from "../../config";
function Dashboard() {
  const handleGetDashboardData = useQuery(["categoryList"], getDashboardData, {
    refetchOnWindowFocus: true,
  });
  return (
    <>
      <div className=" px-4">
        {handleGetDashboardData.isLoading ? (
          <Spinner />
        ) : handleGetDashboardData.status === "error" ? (
          <Errors errorObject={handleGetDashboardData.error} inline />
        ) : (
          <div className="grid grid-cols-4 gap-x-5 mt-8">
            <CardWidgets
              label={"projects"}
              description={`Number of projects on ${PROJECT_NAME} website`}
              border={` border-lime-700`}
              count={handleGetDashboardData.data.data.total_products || 0}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Dashboard;
